import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Shows the Exam Integrity page only to admins the API marks as reviewers.
// The API refuses the data to everyone else; this keeps the page out of their way.
export default function RequireIntegrityReviewer({ children }) {
    const { user } = useAuth();
    if (user?.canReviewIntegrity === true) return children;
    // A session restored from before this check: wait for AuthContext to ask the API.
    if (user && user.canReviewIntegrity === undefined) return null;
    return <Navigate to="/dashboard/data" replace />;
}
